module.exports = __webpack_public_path__ + "img/Gruppenführer_BrB.52a3524c.svg";